import { Component } from "react";
import React from "react";
import { APP_CONFIG } from "../AppConstants";

export class AuthorizeVerify extends Component<any, any> {

    constructor(props) {
        super(props);

        this.onclick = this.onclick.bind(this);
        this.onmouseover = this.onmouseover.bind(this);
        this.onmouseout = this.onmouseout.bind(this);
    }

    componentDidMount() {

    }

    onclick() {
        const url = "https://verify.authorize.net/anetseal/?pid=395d94cd-8c90-4238-a8c2-5ea0d8923caf&amp;rurl=" + window.location.hostname;
        window.open(url + ", 'AuthorizeNetVerification', 'width=600,height=430,dependent=yes,resizable=yes,scrollbars=yes,menubar=no,toolbar=no,status=no,directories=no,location=yes", "_blank");
    }

    onmouseover() {
        window.status = 'http://www.authorize.net/';
    }

    onmouseout() {
        window.status = '';
    }

    render() {
        return (
            <div className="logo-frame" style={{ textAlign: "center", marginTop: "20px" }}>
                <img className="logo" src={APP_CONFIG.AUTHORIZE_ICONS_PATH + "/ccards.png"} style={{ width: "50%" }} />
                <div className="AuthorizeNetSeal">
                    <a href={"#"} onMouseOver={() => { this.onmouseover(); return true; }} onMouseOut={() => { this.onmouseout(); return true; }} onClick={() => { this.onclick(); return false; }}>
                        <img src={"https://verify.authorize.net/anetseal/images/secure90x72.gif"} width="90" height="72" alt="Authorize.Net Merchant - Click to Verify" />
                    </a>
                </div>
            </div>
        );
    }
}

export default AuthorizeVerify